<template>
  <div class="login-page">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <van-icon name="arrow-left" class="back-icon" @click="back()" />
      <span class="nav-title">{{ $t('auth.login_title') }}</span>
    </div>

    <!-- Logo区域 -->
    <div class="logo-section">
      <img src="/img/iqiyi.png" alt="iQIYI" class="logo-img" />
    </div>

    <!-- 登录表单 -->
    <div class="login-form">
      <!-- 账号输入框 -->
      <div class="input-wrapper">
        <van-icon name="user-circle-o" class="input-icon" />
        <input
          v-model="username"
          type="text"
          class="login-input"
          :placeholder="$t('auth.username_place')"
        />
      </div>

      <!-- 密码输入框 -->
      <div class="input-wrapper">
        <van-icon name="lock" class="input-icon" />
        <input
          v-model="password"
          :type="passwordType"
          class="login-input"
          :placeholder="$t('auth.pwd_place')"
        />
      </div>

      <!-- 记住密码 -->
      <div class="remember-section">
        <van-checkbox v-model="rememberPassword" shape="square" icon-size="16px" checked-color="#00d200">
          <span class="remember-text">{{ $t('auth.remember_pwd') }}</span>
        </van-checkbox>
      </div>

      <!-- 登录按钮 -->
      <button class="login-btn" @click="doLogin()">{{ $t('auth.login_btn') }}</button>

      <!-- 注册按钮 -->
      <button class="register-btn" @click="toRegister()">{{ $t('auth.register_btn') }}</button>
    </div>

  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: 'zh',
      password: this.inputValue,
      passwordType: "password",
      rememberPassword: false,
    };
  },
  beforeMount(){
    // localStorage.setItem("lang","ja")
  },
  mounted(){
    // this.lang = localStorage.getItem("lang") || 'ja';
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place") || '請輸入賬號');
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place") || '請輸入密碼');
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: { 
          username: this.username, 
          password: this.password,
        },
      }).then((res) => {
        if (res.code === 200) {
          localStorage.setItem("token", res.data.id);
          this.$toast('登录成功!');
          setTimeout(() => {
            this.$router.push("Home");
          }, 1500);
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
.login-page {
  min-height: 100vh;
  background: #1a1a1a;
  padding: 0 20px;
}

/* 顶部导航栏 */
.top-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  position: relative;
}

.back-icon {
  position: absolute;
  left: 0;
  color: #fff;
  font-size: 40px;
  cursor: pointer;
}

.nav-title {
  color: #00d200;
  font-size: 32px;
}

/* Logo区域 */
.logo-section {
  display: flex;
  justify-content: center;
  padding: 40px 0 30px;
}

.logo-img {
  width: 240px;
  height: auto;
  object-fit: contain;
}

/* 登录表单 */
.login-form {
  padding: 0 10px;
}

/* 输入框样式 */
.input-wrapper {
  display: flex;
  align-items: center;
  background: #3a3a3a;
  border-radius: 6px;
  padding: 0 15px;
  margin-bottom: 12px;
  height: 80px;
}

.input-icon {
  color: #00d200;
  font-size: 30px;
  margin-right: 12px;
  flex-shrink: 0;
}

.login-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 28px;
  height: 100%;

  &::placeholder {
    color: #888;
  }
}

/* 记住密码 */
.remember-section {
  margin: 15px 0 20px;
  display: flex;
  align-items: center;
}

.remember-text {
  color: #fff;
  font-size: 26px;
  margin-left: 4px;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 80px;
  background: #00d200;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 32px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 12px;

  &:active {
    opacity: 0.9;
  }
}

/* 注册按钮 */
.register-btn {
  width: 100%;
  height: 80px;
  background: #00d200;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 32px;
  font-weight: 500;
  cursor: pointer;

  &:active {
    opacity: 0.9;
  }
}

/* 覆盖vant checkbox样式 */
::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #00d200;
  border-color: #00d200;
}

::v-deep .van-checkbox__icon {
  border-color: #666;
}
</style>
